module.exports = __webpack_public_path__ + "img/header-memoireRingsPlatinum@2x.16ef317.jpg";